import { render } from "./Collection.vue?vue&type=template&id=7a1e1f44&scoped=true"
import script from "./Collection.vue?vue&type=script&lang=ts"
export * from "./Collection.vue?vue&type=script&lang=ts"

import "./Collection.vue?vue&type=style&index=0&id=7a1e1f44&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7a1e1f44"

export default script